export default {
  zh: {
    title: '转为客户',
    modalTitle: '已有的相似客户',
    labels: {
      owner: '拥有者',
      opportName: '机会名称',
      acctStatus: '客户状态',
      createAcctName: '客户默认姓名',
      noNewOpport: '不在转换时创建机会',
      exist: '已有',
      similar: '条相似的客户记录',
      viewMore: '查看更多',
      opportType: '机会类型',
    },
  },
  en: {
    title: 'Convert to Account',
    modalTitle: 'Similar Accounts',
    labels: {
      owner: 'Owner',
      opportName: 'Opportunity Name',
      acctStatus: 'Account Status',
      createAcctName: 'Create Account Name',
      noNewOpport: 'Do Not Create New Opportunity',
      exist: 'Has existing ',
      similar: ' similar account/s',
      viewMore: 'View More',
      opportType: 'Opportunity Type',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/ConvertDetails/i18n.js